import { httpsCallable } from "firebase/functions";
import { ACTIVE_YEAR, ORG_ID } from "../constants";
import { functions } from "./FireBase";
import { buildSecureBusinessWriteRequest } from "./secureBusinessWriteRequest";

const secureBusinessWriteCallable = httpsCallable(
  functions,
  "secureBusinessWrite"
);

export async function secureBusinessWrite(action, payload = {}) {
  const result = await secureBusinessWriteCallable(
    buildSecureBusinessWriteRequest(action, ORG_ID, payload)
  );
  return result.data;
}

export function commitSecureInscan({
  barcode,
  partijInfo,
  manualMixOverride = false,
  confirmedInventoryFingerprint = null,
}) {
  return secureBusinessWrite("scanIn", {
    barcode,
    partijInfo,
    manualMixOverride,
    confirmedInventoryFingerprint,
    year: ACTIVE_YEAR,
  });
}

export function commitSecureUitscan({
  barcode,
  machineId,
  machineGroep,
  skipTemperatureCheck = false,
  crateLoanId = null,
}) {
  return secureBusinessWrite("scanOut", {
    barcode,
    machineId,
    machineGroep,
    skipTemperatureCheck,
    crateLoanId,
    year: ACTIVE_YEAR,
  });
}

export function markSecurePalletReady({
  palletId,
  machineId,
  actualPalletWeightKg = 0,
}) {
  return secureBusinessWrite("palletReady", {
    palletId,
    machineId,
    actualPalletWeightKg,
    year: ACTIVE_YEAR,
  });
}

export function setSecureCoolingRowMode(rowId, mode) {
  return secureBusinessWrite("setCoolingRowMode", { rowId, mode });
}

export function setSecureEmptyRowSettings(rowId, handmatigBezet, notitie) {
  return secureBusinessWrite("setEmptyRowSettings", {
    rowId,
    handmatigBezet,
    notitie,
  });
}

export function setSecureMachineRows(machineId, rows) {
  return secureBusinessWrite("setMachineRows", { machineId, rows });
}

export function mutateSecurePlanning(payload) {
  return secureBusinessWrite("planningMutate", payload);
}

export function mutateSecurePlanningProgress(payload) {
  return secureBusinessWrite("planningProgressMutate", payload);
}

export function manageSecureAllowedKisten(operation, barcodes) {
  return secureBusinessWrite("allowedKistenManage", {
    operation,
    barcodes,
  });
}

export function generateSecureWoodenLabels(count, partijInfo) {
  return secureBusinessWrite("woodenLabelsGenerate", {
    count,
    partijInfo,
    year: ACTIVE_YEAR,
  });
}

export function correctSecureInventory({
  sourceRowId,
  barcodes,
  target,
}) {
  return secureBusinessWrite("inventoryCorrect", {
    sourceRowId,
    barcodes,
    target,
    year: ACTIVE_YEAR,
  });
}

export function deleteSecureInventory({ rowId, barcodes, mode }) {
  return secureBusinessWrite("inventoryDelete", {
    rowId,
    barcodes,
    mode,
    year: ACTIVE_YEAR,
  });
}

export function applySecureWeekOrderChanges(changes) {
  return secureBusinessWrite("weekOrdersApply", changes);
}

export function completeSecureWeekOrder(orderId) {
  return secureBusinessWrite("weekOrderComplete", { orderId });
}

export function allocateSecureDeliveryNoteNumber() {
  return secureBusinessWrite("deliveryNoteNumberAllocate", {
    year: ACTIVE_YEAR,
  });
}

export function createSecureDeliveryNote(orderIds) {
  return secureBusinessWrite("deliveryNoteCreate", {
    orderIds,
    year: ACTIVE_YEAR,
  });
}

export function splitSecureDeliveryNote(orderId) {
  return secureBusinessWrite("deliveryNoteSplit", {
    orderId,
    year: ACTIVE_YEAR,
  });
}

export function getSecureDeliveryNoteCaptureTarget(deliveryNoteNumber, year = ACTIVE_YEAR) {
  return secureBusinessWrite("deliveryNoteCaptureGet", {
    deliveryNoteNumber,
    year,
  });
}

export function getSecureCompletedDeliveryNotePhoto(deliveryNoteNumber, year = ACTIVE_YEAR) {
  return secureBusinessWrite("deliveryNotePhotoGet", {
    deliveryNoteNumber,
    year,
  });
}

export function completeSecureDeliveryNote({
  deliveryNoteNumber,
  filePath,
  uploadId,
  year = ACTIVE_YEAR,
}) {
  return secureBusinessWrite("deliveryNoteComplete", {
    deliveryNoteNumber,
    filePath,
    uploadId,
    year,
  });
}

export function createSecureCrateLoan({
  loanId,
  orderId,
  quantity,
  scannedFromCoolingQuantity,
  departureDate,
}) {
  return secureBusinessWrite("crateLoanCreate", {
    loanId,
    orderId,
    quantity,
    scannedFromCoolingQuantity,
    departureDate,
    year: ACTIVE_YEAR,
  });
}

export function returnSecureCrateLoan({
  barcode,
}) {
  return secureBusinessWrite("crateLoanReturn", {
    barcode,
    year: ACTIVE_YEAR,
  });
}

export function startSecureCrateLoan({loanId, orderId, departureDate}) {
  return secureBusinessWrite("crateLoanStart", {
    loanId,
    orderId,
    departureDate,
    year: ACTIVE_YEAR,
  });
}

export function setSecureRetainedCrate({loanId, barcode, retained}) {
  return secureBusinessWrite("crateLoanRetainedSet", {
    loanId,
    barcode,
    retained,
    year: ACTIVE_YEAR,
  });
}

export function finalizeSecureCrateLoan({loanId, quantity}) {
  return secureBusinessWrite("crateLoanFinalize", {
    loanId,
    quantity,
    year: ACTIVE_YEAR,
  });
}

export function setSecureFustTypeVisibility({ kind, typeName, hidden }) {
  return secureBusinessWrite("fustTypeVisibilitySet", {
    kind,
    typeName,
    hidden,
    year: ACTIVE_YEAR,
  });
}
